var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"batchHistoryTable",attrs:{"paging":"","pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"columns":_vm.BatchHistoryCols,"rows":_vm.rows,"stripe":false},on:{"changedPage":_vm.changedPage},scopedSlots:_vm._u([{key:"actionsLeft",fn:function(){return undefined},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }